import farmApi from "api/farmApi";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchDetailTest,
  fetchFarmList,
  fetchFarmListFailed,
  fetchFarmListSuccess,
  fetchListAssessment,
  fetchListAssessmentFailed,
  fetchListAssessmentSuccess,
  fetchStatisticFarms,
  fetchStatisticFarmsFailed,
  fetchStatisticFarmsSuccess,
  fetchTestHistory,
  fetchTestHistoryFailed,
  fetchTestHistorySuccess,
  fetchListStatisticAssessment,
  fetchListStatisticAssessmentSuccess,
  fetchListStatisticAssessmentFailed,
  fetchDetailResultSuccess,
  fetchDetailResultFailed,
  fetchDetailResult,
  fetchFrequencyListSuccess,
  fetchFrequencyListFailed,
  fetchFrequencyList
} from "./adminSlice";

function* getFarmList() {
  try {
    const res = yield call(farmApi.getFarms);
    if (res.responseCode === "00") {
      yield put(fetchFarmListSuccess(res.farms));
    } else {
      yield put(fetchFarmListFailed());
      throw new Error("Failed to fetch data");
    }
  } catch (error) {}
}

function* getTestHistory(action) {
  try {
    const res = yield call(farmApi.getTestHistory, action.payload);
    if (res.responseCode === "00") {
      yield put(fetchTestHistorySuccess(res.listTestSummary));
    } else {
      yield put(fetchTestHistoryFailed());
      throw new Error("Failed to fetch data");
    }
  } catch (error) {}
}

function* getDetailTest(id) {
  try {
    const res = yield call(farmApi.getTestDetailList(id));
    // if (res.responseCode === '00') {
    //     yield put(fetchDetailTestSuccess(res.listTestSummary))
    // }
    // else {
    //     yield put(fetchTestHistoryFailed())
    //     throw new Error('Failed to fetch data')
    // }
  } catch (error) {}
}

function* getStatisticFarms(action) {
  try {
    const res = yield call(farmApi.getStatisticFarm, action.payload);
    if (res.responseCode === "00") {
      yield put(fetchStatisticFarmsSuccess(res.statisticFarms));
    } else {
      yield put(fetchStatisticFarmsFailed());
      throw new Error("Failed to fetch data");
    }
  } catch (error) {}
}

function* getDetailResultList(action) {
  try {
    const res = yield call(farmApi.getDetailResult, action.payload);
    if (res.responseCode === "00") {
      yield put(fetchDetailResultSuccess(res.testDetailsResult));
    } else {
      yield put(fetchDetailResultFailed());
      throw new Error("Failed to fetch data");
    }
  } catch (error) {}
}


function* getAssessment(action) {
  try {
    const res = yield call(farmApi.getAssessment, action.payload);
    if (res.responseCode === "00") {
      yield put(fetchListAssessmentSuccess(res));
    } else {
      yield put(fetchListAssessmentFailed());
      throw new Error("Failed to fetch data");
    }
  } catch (error) {}
}

function* getFrequencyList(action) {
  try {
    const res = yield call(farmApi.getFrequency, action.payload);
    if (res.responseCode === "00") {
      yield put(fetchFrequencyListSuccess(res.repeatation));
    } else {
      yield put(fetchFrequencyListFailed());
      throw new Error("Failed to fetch data");
    }
  } catch (error) {}
}

function* getStatisticAssessment(action) {
  try {
    const res = yield call(farmApi.getStatisticAssessment, action.payload);
    if (res.responseCode === "00") {
      yield put(fetchListStatisticAssessmentSuccess(res));
    } else {
      yield put(fetchListStatisticAssessmentFailed());
      throw new Error("Failed to fetch data");
    }
  } catch (error) {}
}

export function* adminSaga() {
  yield takeLatest(fetchFarmList, getFarmList);
  yield takeLatest(fetchTestHistory, getTestHistory);
  yield takeLatest(fetchDetailTest, getDetailTest);
  yield takeLatest(fetchStatisticFarms, getStatisticFarms);
  yield takeLatest(fetchDetailResult, getDetailResultList);
  
  yield takeLatest(fetchListAssessment, getAssessment);
  yield takeLatest(fetchFrequencyList, getFrequencyList);
  yield takeLatest(fetchListStatisticAssessment, getStatisticAssessment);
}
